import { X } from 'lucide-react'
import { Button } from '../ui/button'
import { StepsOverview } from './index'

export function RouteDetailsScreen({ onBack }: { onBack: () => void }) {
  return (
    <div className='bg-foreground flex flex-col'>
      <div className='flex items-center place-content-between text-center sm:text-left gap-5 px-5 sm:px-8 min-h-12 sm:min-h-20 z-[51]'>
        <div className='size-6' aria-hidden />
        <div className='flex flex-col items-center justify-center'>
          <span className='text-center text-xl font-semibold text-primary z-[52]'>
            Trade route
          </span>
          <span className='text-success-text text-sm'>Trade complete</span>
        </div>
        <Button onClick={onBack} type='button' variant='ghost'>
          <X width={24} height={24} />
          <span className='sr-only'>Close</span>
        </Button>
      </div>
      <StepsOverview className='bg-foreground pb-2' />
    </div>
  )
}
